// extracted by mini-css-extract-plugin
export default {"emptyStateContainer":"FormTemplates__emptyStateContainer___mRvIL","emptyState":"FormTemplates__emptyState___jFE__"};